interface ActiveStorageBlobUrlParams {
  filename: string;
  signed_id: string;
}

export const activeStorageBlobUrl = ({
  signed_id,
  filename,
}: ActiveStorageBlobUrlParams) =>
  `${
    window.location.origin
  }/rails/active_storage/blobs/${signed_id}/${encodeURIComponent(filename)}`;
